import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { getSessionData } from '../../public/site/sessionDataStore.js';
import {
  catalogToValidationRules,
  eppSolutionToValidationRules,
  processCartItems,
} from '../../selfservice/actions/index.js';
import { getShoppingCart, setShoppingCart } from '../../selfservice/common/localStorageUtils.js';
import { updateCartItemPricesWithLatestPrices } from '../../selfservice/common/shopping-cart/shoppingCartFunctions.js';
import { isEoeOrPunchout } from '../constants/pathVariables.js';
import { findCatalogById } from '../utils/catalogUtils.js';
import { deepEqual } from '../utils/objectUtils.js';
import type { OnlineModel } from '../../generated/api/models.js';
import type { CartItemType } from '../../selfservice/common/shopping-cart/shoppingCartInterfaces.js';
import type { State } from '../../selfservice/common/store.js';

export const useSyncCartPricesWithModels = (onlineModels: OnlineModel[]) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isEmployee = isEoeOrPunchout(pathname);
  const { catalogs, selectedCatalogCode } = useSelector(
    (state: State) => ({
      catalogs: state.selfservice?.virtualCatalogs?.items,
      selectedCatalogCode: state.selfservice?.virtualCatalogs?.selectedCatalogCode,
    }),
    deepEqual
  );

  useEffect(() => {
    const cartItems = JSON.parse(getShoppingCart()) as CartItemType[];
    const { cartItems: updatedCartItems, pricesUpdated } = updateCartItemPricesWithLatestPrices(
      cartItems,
      onlineModels
    );
    if (!pricesUpdated) {
      return;
    }

    const updatedCart = JSON.stringify(updatedCartItems);
    const validationRules = isEmployee
      ? catalogToValidationRules(findCatalogById(catalogs, selectedCatalogCode, true))
      : eppSolutionToValidationRules(getSessionData().companyInfo?.eppSolution);
    setShoppingCart(updatedCart);
    dispatch(processCartItems(false, isEmployee, updatedCart, validationRules));
  }, [catalogs, dispatch, isEmployee, onlineModels, selectedCatalogCode]);
};
